import { toRaw } from 'vue';
import { TabNames } from '../modules/Constants';

export class BaseModel {
    Display = [];
    Headers = [];
    Numerics = [];
    DataProcessor = undefined;
    TabName = TabNames.DEFAULT;
    TabIndex = 1;
    isDataReady = false;
    isFormattingReduced = false;

    constructor(exchangeRates, years) {
        if (exchangeRates) {
            this.ExchangeRates = exchangeRates.map(x => x);
        }

        if (years) {
            this.Years = years?.map(x => x);
        }
    }

    setFormattingReduced(records, columns) {
        let cellCount = records.length * columns.length;

        if (cellCount > 1000000) {
            this.isFormattingReduced = true;
        }
    }

    defaultHeader() {
        let settings = {
            fontWeight: 'bold',
            textAlign: 'center',
            color: 'white',
            backgroundColor: '#838383',
            verticalAlign: 'middle',
        }

        return settings;
    }

    defaultCell() {
        let settings = {
            verticalAlign: 'middle',
            textAlign: 'center',
            backgroundColor: undefined,
        }

        return settings;
    }

    formatSheet() {
        let records = toRaw(this.Display);
        let columns = Array(this.Headers.length).fill(0).map(() => ({ width: 100, numeric: false }));
        columns.forEach((col, index) => {
            this.Numerics.forEach(range => {
                if (index >= range.start && index <= range.end) {
                    col.numeric = true;
                    col.format = range.format;
                }
            })
        })

        let result = {}
        result.rows = records.map(
            (row, rowIndex) => {
                let result = {}
                result.cells = columns.map((column) => {
                    let cell = {};
                    if (!this.isFormattingReduced) { //JG: Syncfusion Grid performance suffers with more than 1,000,000 cells. (https://www.syncfusion.com/forums/171098/spreadsheet-a-long-time-to-render)
                        if (rowIndex === 0) {
                            cell = {
                                style: this.defaultHeader(),
                                format: "@",
                                wrap: true
                            }
                        } else {
                            if (column.numeric) {
                                cell = {
                                    style: this.defaultCell(),
                                    format: column.format ?? '#,##0.0000',
                                    wrap: true
                                }
                            } else {
                                cell = {
                                    style: this.defaultCell(),
                                    format: "@",
                                    wrap: true
                                }
                            }
                        }
                    }
                    return cell;
                })
                return result;
            })

        result.columns = columns.map((col) => ({ width: col.width }));

        result.rows.forEach((row, rowIndex) => {
            row.cells.forEach((cell, columnIndex) => {
                cell.value = records[rowIndex][columnIndex];
            })
        })

        if (this.supplementalFormatting) {
            return this.supplementalFormatting(result);
        }

        return result;

    }

    process(data) {
        let processor = Object.assign(this.DataProcessor); //JG: Create a copy of the defined Processor so that way it can be destroyed after usage and not keep any data in memory. 
        let result = processor.process(data);

        this.Headers = result.headers
        this.Display = result.display;
        this.Numerics = result.numerics;

        processor = undefined;
        this.setFormattingReduced(this.Display, this.Headers);
        this.isDataReady = true;

        return {
            headers: this.Headers,
            display: this.Display,
            numerics: this.Numerics
        };
    }

    /**
     * Takes a positive integer and returns the corresponding column name.
     * @param {number} num  The positive integer to convert to a column name.
     * @return {string}  The column name.
    */
    excelLetter(num) {
        for (var ret = '', a = 1, b = 26; (num -= a) >= 0; a = b, b *= 26) {
            ret = String.fromCharCode(parseInt((num % b) / a) + 65) + ret;
        }

        return ret;
    }
}